{
  "currency-symbol": "$",
  "data-refresh": {
    "availability": {
      "label": "When are you available to start?",
      "now": "Available Now",
      "specific-date": "Available on a Specific Date",
      "specific-date-placeholder": "Availability date",
      "with-notice": "Available with notice",
      "with-notice-placeholder": "Enter the number of weeks notice"
    },
    "check-in": "When can we check in with you again?",
    "employment-type": {
      "label": "Work Type*",
      "temp": "Temp",
      "temp-to-perm": "Temp-to-perm",
      "perm": "Permanent",
      "error": "Please select at least one of permanent, temp, or temp-to-perm"
    },
    "error": {
      "required": "{{fieldName}} is a required field",
      "at-least-one": "At least one option must be selected",
      "at-least-one-groups": "At least one option from each group must be selected"
    },
    "header": {
      "text": "Update your job preferences",
      "subtext-required": "All fields are required"
    },
    "hourly-rate": {
      "label": "Hourly Rate{{required}}",
      "target": "Target",
      "minimum": "Minimum",
      "per-hour": "/hr",
      "error-minimum": "Please enter a value into minimum hourly rate",
      "error-target": "Please enter a value into target hourly rate",
      "error-both": "Please enter a value  into minimum and target hourly rate"
    },
    "hours": {
      "label": "Hours",
      "full-time": "Full Time",
      "part-time": "Part Time",
      "error": "Please select at least one of full time or part time"
    },
    "last-updated": "Last updated on {{lastUpdated}}",
    "location": "Where are you located?",
    "opportunities": "Are you considering new opportunities?",
    "read-only": {
      "header": "Timing is everything",
      "subtext": "Right now is prime time to get you in the mix for some amazing job opportunities. We're checking in to make certain we're accurately representing your preferences. Please confirm the following information is correct:",
      "minimum-hourly": "Minimum hourly rate:",
      "target-hourly": "Target hourly rate:",
      "minimum-salary": "Minimum salary:",
      "target-salary": "Desired salary:",
      "preferred-work-type": "Preferred work type:",
      "preferred-hours": "Preferred hours:",
      "preferred-workplace": "Preferred workplace:",
      "looks-good": "Looks Good",
      "edit": "Edit"
    },
    "salary": {
      "label": "Yearly Salary{{required}}",
      "target": "Target",
      "minimum": "Minimum",
      "per-year": "/yr",
      "error-minimum": "Please enter a value into minimum salary",
      "error-target": "Please enter a value into target salary",
      "error-both": "Please enter a value  into minimum and target salary"
    },
    "submit-go-ahead": {
      "label": "Can we go ahead and submit you to our clients for positions matching your preferences below?",
      "yes": "Yes, go ahead.",
      "no": "No, check with me first."
    },
    "success-page": {
      "heading": "THANK YOU FOR LETTING US KNOW MORE ABOUT YOUR CAREER GOALS!",
      "update-profile-desc": "If you’ve picked up a little more experience since we last heard from you, it’d be great to see an updated CV or portfolio.",
      "find-jobs-desc": "Find more job opportunities on the Aquent job board."
    },
    "workplace": {
      "label": "Work Location*",
      "on-site": "On-site",
      "remote": "Remote",
      "error": "Please select at least one of on-site or remote"
    }
  },
  "eeoc-form": {
    "age-group": "Age Group",
    "armed-forces-service-medal-vet": "Armed Forces Service Medal Veteran",
    "authorized-to-work": "Are you authorized to work in the United States?",
    "contact-us": {
      "text_part1": "Aquent is an equal opportunity employer. We evaluate qualified applicants without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, disability, veteran status, and other legally protected characteristics. Aquent is committed to working with and providing reasonable accommodation to individuals with disabilities. If, because of a medical condition or disability, you need a reasonable accommodation for any part of the employment process, please send an e-mail to ",
      "mailto": "compliance@aquent.com",
      "text_part2": " and let us know the nature of your request and your contact information. The “EEO is the Law” poster is available ",
      "link-text": "here."
    },
    "delete-modal": {
      "title": "EEO Information Deletion Request",
      "content": "For the deletion of equal employment opportunity data we ask candidates, former employees, and current employees to complete the webform <a href='https://privacyportal-cdn.onetrust.com/dsarwebform/05f24bb5-a0c4-43d4-966e-05606d5be9ca/def13fac-05a5-4eb5-9fd8-b2b56ff6cb97.html'> here</a> or call us at 1-877-727-8637. Before we can fulfill your request you must verify your identity.",
      "button-text": "Close"
    },
    "details": "details",
    "disability-header": "This list includes but is not limited to:",
    "disability-details": {
      "items": {
        "autism": "Autism",
        "bipolar disorder": "Bipolar disorder",
        "blindness": "Blindness",
        "cancer": "Cancer",
        "cerebral palsy": "Cerebral Palsy",
        "deafness": "Deafness",
        "diabetes": "Diabetes",
        "epilepsy": "Epilepsy",
        "hiv infection": "HIV infection",
        "intellectual disabilities": "Intellectual disabilities",
        "major depressive disorder": "Major depressive disorder",
        "mobility impairments requiring the use of a wheel chair": "Mobility impairments requiring the use of a wheel chair",
        "multiple sclerosis": "Multiple sclerosis",
        "muscular dystrophy": "Muscular dystrophy",
        "obsessive-compulsive disorder": "Obsessive-compulsive disorder",
        "partial or completely missing limbs": "Partial or completely missing limbs",
        "post-traumatic stress disorder": "Post-traumatic stress disorder",
        "schizophrenia": "Schizophrenia"
      }
    },
    "disability-no": "No",
    "disability-yes": "Yes",
    "do-not-wish-to-answer": "I do not wish to answer",
    "error": "{{fieldName}} is a required field.  Select “I do not wish to answer” if you do not want to disclose this information.",
    "error-immigration": "Immigration and employment authorization information is required. Please select an answer.",
    "ethnicity": "Ethnicity",
    "ethnicity_other": "Other",
    "ethnicity-details": {
      "white": "White (not Hispanic or Latino) – A person having origins in any of the original peoples of Europe, North Africa, or the Middle East.",
      "black": "Black or African American (not Hispanic or Latino) – A person having origins in any of the black racial groups of Africa.",
      "hispanic": "Hispanic or Latino – A person of Mexican, Puerto Rican, Cuban, Central or South American, or other Spanish culture or origin, regardless of race.",
      "asian": "Asian (not Hispanic or Latino) – A person having origins in any of the original peoples of the Far East, Southeast Asian, or the Indian subcontinent including for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.",
      "american-indian": "American Indian/Alaskan Native (not Hispanic or Latino) – A person having origins in any of the original peoples of North America and South America (including Central America), and who maintains tribal affiliation or community attachment.",
      "native-hawaiian": "Native Hawaiian or Other Pacific Islander (not Hispanic or Latino) – A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.",
      "two-plus-races": "Two or More Races (not Hispanic or Latino) – All persons who identify with more than one of the above six races."
    },
    "equal-opportunity-header": "EQUAL EMPLOYMENT OPPORTUNITY INFORMATION",
    "equal-opportunity-subtext": "Providing this information is strictly voluntary. The law prohibits employers from taking an adverse action against you because you choose not to provide this information.",
    "gender": "Gender Identity",
    "gender_other": "Other",
    "immigration-header": "IMMIGRATION AND EMPLOYMENT AUTHORIZATION INFORMATION",
    "immigration-subtext": "Lorem ipsum dolor sit amet, consectetur adipiscing elitctetur adipiscing elitctetur adipiscing elit.",
    "fostering-a-diverse": "We Are Committed to Fostering a Diverse and Inclusive Community of Talent",
    "fostering-a-diverse-subtext": " Please update your equal opportunity employment data below.",
    "lgbtq": "Do you identify as a member of the LGBTQIA+ community?",
    "lgbtq-details": {
      "details": "LGBTQIA+ stands for lesbian, gay, bisexual, transgender, and queer or questioning, with the + referring to a wider variety of gender, romantic, and sexual identities not limited to those spelled out in the acronym."
    },
    "neurodivergent": "Do you identify as Neurodivergent?",
    "neurodivergent-details": {
      "details1": "Neurodivergent means having a brain that functions differently in ways that interpret and work with information.",
      "details2": "Some examples include but are not limited to ADHD, autism, dyslexia, dyscalculia."
    },
    "newly-separated-vet": "Recently Separated Veteran",
    "not-a-vet": "I am not a protected veteran",
    "other-protected-vet": "I am a protected veteran, but I choose not to self-identify the classifications to which I belong",
    "redeployme-message-one-more-thing": "One more thing before you go!",
    "redeployme-message-please-consider": "Please consider filling out Aquent's Equal Employment Opportunity Form.",
    "require-sponsorship": "Do you now, or will you at any point in the future, require immigration related sponsorship?",
    "special-disabled-vet": "Disabled Veteran",
    "self-identification-disability": "Do you identify as differently-abled?",
    "success-find-jobs": "Find Jobs",
    "success-find-jobs-info": "Find other job opportunities",
    "success-header": "THANK YOU FOR SHARING YOUR DIVERSITY AND INCLUSION DATA",
    "success-learn-more": "Learn More",
    "success-learn-more-info": "Learn more about our diversity and inclusion initiatives",
    "success-update-profile": "Update Profile",
    "success-update-profile-info": "Update your Aquent profile",
    "thanks": "{{name}}, thank you for sharing your equal employment information!",
    "using-data": {
      "header": "HOW WE’RE USING THIS DATA",
      "subtext": "As part of that commitment, we encourage you to share the following information. While you have the option to select “I do not wish to answer” on each question, we value any information you are comfortable sharing. The data you provide will be used, in aggregate, to improve diverse representation in our candidate submissions, to direct talent outreach, and to develop resources that support our talent community and foster an inclusive environment. Your data will not be visible to your recruiter."
    },
    "veteran-details": {
      "disabled-vet": "Disabled Veteran– means (1) A veteran of the U.S. military, ground, naval or air service who is entitled to compensation (or who but for the receipt of military retired pay would be entitled to compensation) under laws administered by the Secretary of Veterans Affairs, or (2) A person who was discharged or released from active duty because of a service-connected disability.",
      "medal-veteran": "Armed Forces Service Medal Veteran– means any veteran who, while serving on active duty in the U.S. military, ground, naval or air service, participated in a United States military operation for which an Armed Forces service medal was awarded pursuant to Executive Order 12985 (61 FR 1209, 3 CFR, 1996 Comp., p. 159).",
      "separated-vet": "Recently Separated Veteran– means a veteran during the three-year period beginning on the date of such veteran’s discharge or release from active duty in the U.S. military, ground, naval or air service.",
      "wartime-vet": "Active Duty Wartime or Campaign Badge Veteran – means a veteran who served on active duty in the U.S. military, ground, naval or air service during a war or in a campaign or expedition for which a campaign badge has been authorized under the laws administered by the Department of Defense."
    },
    "veteran-status": "Veteran Status",
    "vietnam-vet": "Active Duty Wartime Or Campaign Badge Veteran"
  },
  "footer": {
    "application-support": "Application Accommodation Support",
    "copyright-aq": "© {{year}} Aquent",
    "privacy-policy": "Privacy Policy :",
    "aquent": "Aquent",
    "skill": "Skill",
    "impressum": "Impressum",
    "logout": "Logout",
    "logout-confirmation": "Are you sure you want to logout?",
    "questions-email": "questions@aquent.com"
  },
  "web-style-top-bar": {
    "preferences-confirmed": "Confirm Preferences",
    "preferences-edit": "Edit Preferences"
  },
  "redeploy": {
    "preferences-edit-header": "Edit your job preferences",
    "take-a-moment": "Take a moment to edit your preferences to ensure we're representing you accurately.",
    "phone": "Phone",
    "location": "Location",
    "available-to-start": "Available to start",
    "weeks-notice": "Weeks notice",
    "employment-type-label": "Work Type",
    "workplace-label": "Work Location",
    "hourly-rate-label": "Hourly Rate",
    "salary-label": "Yearly Salary",
    "permission-to-submit": "Aquent has permission to submit you to clients that match these preferences?",
    "resume-header": "Resume",
    "current-resume": "Current resume ",
    "uploaded-on": "uploaded on ",
    "upload-resume": "Upload New Resume",
    "cancel": "Cancel"
  },
  "thank-you": "Thank you. You're all set!",
  "no": "No",
  "submit": "Submit",
  "delete": "Delete",
  "yes": "Yes",
  "gather": {
    "complete-profile": "Complete your profile",
    "eeoc-form-title": "Equal Opportunity",
    "enter-url": "Enter a URL",
    "error": {
      "general": "Hmm...we're having trouble with this URL. Please make sure it's correct before continuing.",
      "inaccessible": "Hmm...we're having trouble accessing your site. Please make sure your URL is correct before continuing.",
      "not-found": "Hmm...we're having trouble finding your site. Please make sure your URL is correct before continuing."
    },
    "apply": "APPLY",
    "not-a-fit": "NOT A FIT",
    "interested": {
      "label": "INTERESTED",
      "title": "Update Availability",
      "confirm": {
        "title": "Thank you!"
      },
      "compensation": "What's your ideal compensation?",
      "compensation-and-availability": "Compensation & Availability",
      "availability": "Availability",
      "location": "Location",
      "desired-pay": "Desired Pay",
      "available-to-start": "When would you be available to start?",
      "enter-annual-salary": "Enter annual salary",
      "enter-hourly-rate": "Enter hourly rate",
      "enter-total-compensation": "Enter total compensation",
      "optional": "(Optional)",
      "professional-profile": "Professional Profile",
      "immediately": "Immediately",
      "non-integer-number-of-weeks-error": "Please enter a non-zero integer value for number of weeks notice"
    },
    "interest": {
      "title": "Role Interest"
    },
    "notice-text": "How much notice?",
    "immediately": "Immediately",
    "with-notice": "With notice",
    "two-weeks-notice": "Two Weeks Notice",
    "specific-date": "On A Specific Date",
    "thank-you": "Thank you!",
    "thank-you-text": "Your interest and availability have been sent to the agent working on this position. They will review it and get in touch if you are a fit.",
    "second-time": {
      "thank-you-text": "We received your response on {{responseDate}}. If you have any questions, please contact {{agentName}} at {{agentEmail}}."
    },
    "loading-text": "Just a moment...",
    "update-profile": "Update profile",
    "update-profile-text": "New resume or portfolio? Update your information so agents and clients are seeing your best work",
    "update-my-profile": "Update My Profile",
    "complete-review-text": "Request reviews from past colleagues to showcase your strengths, skills and potential.",
    "add-reviews": "ADD REVIEWS",
    "track-your-status": "Track your status",
    "track-status-text": "See your status for roles that you are considering. We will still reach out to you with urgent updates.",
    "track-my-status": "Track My Status",
    "see-more-jobs": "See more jobs",
    "see-more-jobs-text": "We are working on new roles every day! Check out more postings that might interest you and show your interest.",
    "visit-job-center": "Visit Job Center",
    "description": "DESCRIPTION",
    "showcase": "Please make sure we are showcasing your best work:",
    "starting": "Starting",
    "full-time": "FULL-TIME ",
    "part-time": "PART-TIME ",
    "jobId": "Job ID #",
    "agent": "Agent: ",
    "availability": {
      "next": "Next",
      "confirm": "Confirm",
      "submit": "Submit",
      "response-date": "MMM dd, yyyy",
      "error": "We are having some trouble saving your availability. Please try again."
    },
    "client-description": "CLIENT DESCRIPTION",
    "other-requirements": "OTHER REQUIREMENTS",
    "not-interested": {
      "actively-looking": "Actively Looking",
      "available-to-start": "When are you available to start?",
      "be-in-touch": "Great! We'll be in touch.",
      "check-in-again": "When should we check in again?",
      "hear-from-us": "Would you like to hear from us if we find a great opportunity?",
      "job-search": "Where are you in your job search?",
      "label": "No Thanks",
      "title": "Not Interested",
      "check-back-few-months": "Check back in a few months",
      "check-back-on": "Check back on a specific date",
      "company-or-industry": "Company or Industry",
      "choose-a-date": "Choose a date",
      "pay-rate": "Pay rate",
      "location": "Location",
      "skill-set": "Mismatched skill set",
      "other": "Other",
      "tell-us-more": "Tell us more:",
      "tell-us-more-interested": "Additional notes for us?",
      "primary-reason": "Please let us know why this wasn't a match (choose all that apply):",
      "send-feedback": "Send Feedback",
      "submit": "Submit",
      "thank-you-text": "We have received your feedback and will use it to improve our notifications.",
      "refer-friend": "Refer a friend",
      "learn-more": "Learn More",
      "confirm": {
        "title": "Thank you!"
      },
      "reason": {
        "skill-set-mismatch": "Mismatched Skill Set",
        "level-mismatch": "Mismatched Level",
        "pay-rate": "Pay Rate",
        "location": "Location",
        "industry": "Industry",
        "not-actively-looking": "Not actively looking",
        "other": "Other"
      },
      "refer-text": "Know someone who'd be great for this? Let us know! See details on how our cash bonuses work for Talent Rewards.",
      "still-interested": "Are you still interested in hearing about other opportunities?",
      "still-interested-confirmation": "When would you be available to start a new opportunity?",
      "thank-you": "Thanks for your response",
      "may-we-check-in": "Let us know when we can check in again.",
      "not-currently-looking": "Not Currently Looking",
      "open-to-opportunities": "Open To Good Opportunities",
      "other-job-postings": "There are plenty of other jobs available on our jobs website. Come take a look!",
      "thank-you-page": {
        "title": "Thank you!",
        "message": "Your preferences have been saved to your profile. You can modify them anytime by visiting MyAquent."
      },
      "letting-us-know": "Thanks for letting us know!",
      "update-your-preferences": "To ensure we can surface opportunities that are a fit, take a moment to update your resume and preferences within these following screens.",
      "got-it": "Got It",
      "let-us-know": "Let us know why this wasn't a fit",
      "choose-all-that-apply": "Choose all that apply",
      "get-better-matches": "Update your resume and preferences to get better matches.",
      "continue-to-preferences": "Continue to Preferences"
    },
    "back-to-posting": "< Back to posting",
    "not-interested-text": "Please tell us why this role didn't interest you so we can improve our notifications.",
    "yes": "Yes",
    "no": "No",
    "job-closed": {
      "sorry": "We're sorry",
      "sorry-text": "Thank you for your response, but it turns out this job is no longer available."
    },
    "invalid-id": {
      "text": "We’re sorry, but we can't seem to find the page you were looking for.",
      "oops": "Oops!"
    },
    "already-a-talent": {
      "text": "It appears you are already working with us on this opportunity. Please reach out to your agent with any questions:",
      "oops": "Oops!"
    },
    "thank-you-page": {
      "title": "Thank you! You’re now in our consideration pool!",
      "message": "Your interest and availability have been sent to the agent working on this position.\nIf your profile is shortlisted, we’ll be in touch with next steps.",
      "button": "Go to MyAquent"
    },
    "greetings": "Hi ",
    "header1": "Here is a new role we are working on that matches your ",
    "header2": " on file. Please review the details and let us know if you are interested below.",
    "preferences": "preferences",
    "footer-address": "501 Boylston Street, 3rd Floor, Boston, MA 02116",
    "privacy-policy": "This is not a marketing text message. The purpose of this message is to communicate important information regarding your business with Aquent.",
    "privacy": "Privacy",
    "resume": {
      "update": "If you have an updated resume, you can include it here:",
      "last-updated": "Last updated {{latestResumeDate}}",
      "upload-a-new-resume": "Uploading a new resume will update your education, skills, and experience on MyAquent",
      "upload": "Upload File",
      "none": "No file selected"
    },
    "titles": {
      "role-interest": "Role Interest"
    }
  },
  "double-opt-in": {
    "confirm": {
      "header": "Thank you and welcome!",
      "sub-text": "You are successfully subscribed to Aquent communications."
    }
  },
  "pre-interview-questions": {
    "category": {
      "authorization": "authorization",
      "location": "location",
      "relocation": "relocation",
      "travel": "travel"
    },
    "question": {
      "0": "Are you authorized to work in the US?",
      "1": "Do you require a work visa sponsorship now or in the future?",
      "2": "Are you located in the US?",
      "3": "Are you able to work on-site at the client location?",
      "4": "How many days per week are you able to work on site?",
      "5": "Are you willing to relocate?",
      "6": "Are you willing to relocate at your own expense?",
      "7": "How much time are you willing to travel for this position?"
    },
    "header": "Pre-interview Questions",
    "header-description": "This is an optional feature to ask candidates additional questions in the job application and Gather process. You have the option to select up to 3 optional questions.",
    "no-questions-selected-message": "You haven't selected any questions yet. Click the edit button to get started! 🙂",
    "answer-options": "Answer options",
    "answer-option-yes": "Yes",
    "answer-option-no": "No",
    "answer-header-description": "Please answer the following questions to the best of your ability. Questions are optional.",
    "textarea-max-characters": "(character limit: 500)"
  },
  "talent-availability": {
    "error": {
      "header": "Something went wrong",
      "body": "We were unable to process your request. Please try again later."
    },
    "unsubscribe-success": {
      "header": "Okay, no problem",
      "no-more-job-notifications": "You've been unsubscribed. We won't send you anymore opportunity alert emails. You can update your availability anytime in MyAquent.",
      "did-not-meant-to-unsubscribe": "Wait, I didn't mean to unsubscribe!"
    },
    "subscribe-success": {
      "header": "Great news!",
      "notifications-back": "Okay, you are now able to receive job opportunity alert emails. You can update your availability anytime in MyAquent.",
      "go-to-myaquent": "Go to MyAquent"
    }
  },
  "talent-happy-path": {
    "general-application": {
      "header-overline-text": "Join our",
      "header-text": "Talent Community"
    },
    "welcome-text": "Welcome to MyAquent",
    "radio": {
      "yes": "Yes",
      "no": "No",
      "check-later": "Check with me later",
      "other-option": "Other"
    },
    "buttons": {
      "back": "Back",
      "do-later": "I'll do this later",
      "finish": "Finish",
      "lets-do-this": "Let's do this",
      "next": "Next",
      "submit": "Submit",
      "cancel": "Cancel",
      "ok": "OK",
      "yes": "Yes",
      "go-to-myaquent": "Go to MyAquent",
      "explore-jobs": "Explore Jobs",
      "continue-to-talent-community": "Continue to Talent Community",
      "update-profile": "Update Profile"
    },
    "labels": {
      "date": "Date"
    },
    "select-list": {
      "yes": "Yes",
      "no": "No",
      "no-answer": "I do not wish to answer",
      "please-select-text": "Please Select"
    },
    "talent-profile": {
      "header": "Talent Profile",
      "authorization-page": {
        "title": "Authorization",
        "location": "Where are you located?",
        "authorized-in-location": "Are you authorized to work in the location of the Job",
        "sponsorship": "Do you now, or will you at any point in the future, require immigration related sponsorship?"
      },
      "preferences": {
        "title": "Employment Preferences",
        "type": "Employment Type?",
        "work-hours": "Work Hours?",
        "workplace": "Workplace Preference?",
        "types": {
          "temp": "Temporary",
          "temp-to-perm": "Temporary-to-Perm",
          "perm": "Permanent",
          "full-time": "Full Time",
          "part-time": "Part Time",
          "onsite": "Onsite",
          "remote": "Remote",
          "hybrid": "Hybrid"
        }
      },
      "opportunities": {
        "title": "Employment Opportunities",
        "new-opportunities": "Are you open for new opportunities?",
        "when-available": "When are you available to start?",
        "submit-other": "May we submit you to other positions matching your preferences?",
        "availability-types": {
          "now": "Now",
          "date": "Specific Date",
          "notice": "With Notice",
          "weeks-notice": "Weeks Notice"
        }
      },
      "salary": {
        "title": "Compensation",
        "hourly-pay": "Hourly Pay",
        "desired-hourly": "Desired Hourly Rate",
        "minimum-hourly": "Minimum Hourly Rate",
        "salary-pay": "Salary Pay",
        "desired-salary": "Desired Salary",
        "minimum-salary": "Minimum Salary",
        "salary-error": "Minimum pay cannot be more than desired pay.",
        "hourly-error": "Minimum pay cannot be more than desired pay."
      },
      "splash-page": {
        "content": "To get matched with more opportunities, start filling your profile",
        "complete-profile-button": "Start my profile"
      },
      "later-modal": {
        "header": "Complete the profile later?",
        "description": "If so, we will email you a link to continue this portion of the application."
      },
      "progress-bar-description": {
        "of": "of",
        "sections": "sections"
      },
      "file-upload": {
        "resume": "Resume",
        "rirekisho-resume": "Rirekisho Resume",
        "keirekisho-resume": "Keirekisho Resume"
      }
    },
    "initial-interview-questions": {
      "header-overline-text": "Initial Interview Questions",
      "initial-interview-question": "Initial Interview Question",
      "progress-bar-text": "{{currentQuestionNumber}} of {{totalQuestions}} questions",
      "progress-bar-text-loading": "{{currentQuestionNumber}} of ",
      "progress-bar-text-loading-end": "questions",
      "this-question-was-ai-generated":  "This question was generated with AI assistance",
      "standard-question": "Tell us about why you would be a good fit for this position",
      "splash-page": {
        "check-for-questions": "Let’s see if we have initial interview questions for you to answer",
        "content-text-when-questions": "Answer initial interview questions",
        "content-text-when-no-questions": "No questions to answer",
        "heading-when-questions": "Answer initial interview questions",
        "next-button-text": "Next",
        "next-button-text-lets-do-this": "Let's do this",
        "sub-heading-when-questions": "Completing this step can help you stand out from other candidates",
        "header-overline-text": "Thank you for submitting your application"
      },
      "application-submit-page": {
        "header": "Thank you for submitting your application!",
        "header-interest": "Thank you for your interest in this role!",
        "sub-header": "Let’s answer some questions. Completing this step can help you stand out from other candidates."
      },
      "no-questions-page": {
        "header": "No questions left to answer",
        "sub-header": "To get matched with more opportunities, submit your answer and move to the next section"
      },
      "hang-tight-page": {
        "header": "Hang tight! We are generating more questions to help you stand out"
      }
    },
    "video-interview": {
      "landing-page": {
        "header": "Record two video answers on your own",
        "body": "Answer two questions on video so recruiters can match you to this job and others like it. You record on your own, with no live call. The videos take about 5 minutes.",
        "start-button": "Record my answers"
      },
      "page": {
        "header": "Video Interview",
        "body": "Answer the questions in the window below.",
        "loading": "Setting up your video interview...",
        "iframe-title": "Video interview questions",
        "open-in-new-tab": "Having trouble? Open the interview in a new tab",
        "continue-button": "Continue",
        "deferred": {
          "header": "Video interview",
          "body": "We can't start your video interview right now. You can carry on with your application \u2014 this step is optional."
        },
        "already-done": {
          "header": "You've already recorded your answers",
          "body": "Thanks, we have your video answers on file. You can carry on with your application."
        }
      }
    },
    "quick-apply": {
      "error" : {
        "invalid-location" : "Please select a valid location from the suggestions.",
        "failed-to-get-location": "Failed to get location details. Please try again."
      },
      "header-overline-text": "Apply for",
      "thank-you-page": {
        "title": "Thank you! You’re now in our consideration pool!",
        "message": "Your interest and availability have been sent to the agent working on this position.\nIf your profile is shortlisted, we’ll be in touch with next steps.",
        "general-application-message": "Manage your account in our MyAquent portal. Search for exciting job opportunities on our website.",
        "button": "Go to MyAquent",
        "button-jp": "Explore job listings"
      },
      "welcome-page": {
        "title": "Welcome back,",
        "continue-message": "Let's continue where you left off.",
        "job-board-message": "You are already a candidate for this position. Feel free to explore our other job listings.",
        "job-board-button": "Explore job listings"
      },
      "invite-page": {
        "apply": "Apply",
        "thank-you-header": "Thanks for connecting with Aquent!",
        "thank-you-message": "Following our recent exchange, we believe your skills and experience could make you a great fit for this opportunity!\n\nPlease enter your email address and click 'Apply'. We are excited to continue the conversation.",
        "see-job-description": "See Job Description",
        "role-summary": "Role Summary And Responsibilities",
        "application-close-soon": "Applications are closing soon",
        "posting-start-date": "Starting {{postingStartDate}}",
        "location": {
          "remote": "Remote"
        },
        "hours": {
          "full-time": "Full-Time",
          "part-time": "Part-Time"
        },
        "placement-type": {
          "temp": "TEMP",
          "perm": "PERM",
          "project": "PROJECT",
          "temp-to-perm": "TEMP-TO-PERM"
        },
        "other": "Other",
        "pay-range-min-and-max": "{{min}} - {{max}}",
        "pay-range-single-value": "{{pay}}"
      },
      "submit-page": {
        "required-fields": "(All fields are required unless specified otherwise)",
        "email": "Email",
        "email-address": "Email Address",
        "name": "Name",
        "firstName": "First Name",
        "lastName": "Last Name",
        "phone": "Phone Number",
        "postal-code": "Enter your street, city, or postal code",
        "homeLocation": "Home Location",
        "homeLocation-placeholder":"Enter zip/postal code",
        "homeLocation-placeholder-non-North-America":"Enter your street, city, or postal code",
        "homeLocation-placeholder-general-application":"Street, City or Postal Code",
        "homeLocation-required-zip":"Please enter a valid zip/postal code",
        "homeLocation-required-location":"Please enter a valid street, city, or postal code",
        "communication-preferences": {
          "label": "Communication Preferences",
          "copy": "I want to receive text messages for this application and related opportunities. Text rates may apply"
        },
        "double-opt-in": {
          "copy": "Tick this box to stay updated with new job opportunities, industry news, and services from Aquent | Skill. We'll send a follow-up email to confirm your consent."
        },
        "personal-info": "Personal Info",
        "edit-personal-info": "To edit personal data go to ",
        "myaquent": "MyAquent",
        "welcome-back": "Welcome back! Your profile is on file — update it to reflect your latest experiences.",
        "all-fields-required": "(All fields are required unless specified otherwise)",
        "terms": {
          "copy": "By submitting an application for this role, you are registering with Aquent as a Talent for work finding services. An account is created in MyAquent where you can manage & update your applications & preferences.",
          "message": "By submitting this form, you are registering with Aquent as a Talent for work finding services. An account is created in MyAquent where you can manage & update your applications & preferences.",
          "agree": " I understand and agree to the Aquent ",
          "terms-of-service": "Terms of Service",
          "communication-preferences": "I agree to receive communications and updates via email."
        },
        "optional": "optional",
        "professional-profile-placeholder": "Professional Profile URL",
        "portfolio-placeholder": "Website, Vimeo, Behance etc",
        "professional-profile-hint": "e.g. LinkedIn, Indeed, etc.",
        "profiles-portfolios": "Profiles & Portfolios",
        "optional-text": "optional (6 total)",
        "profile": "Professional Profile",
        "portfolio-work": "Portfolio & Work",
        "add-profile": "Add Profile",
        "add-portfolio": "Add Work",
        "password": "Password",
        "resume": {
          "last-updated": "last updated",
          "upload-text": "Upload new resume here",
          "file-types": "(.pdf, .doc, .docx, .txt, .rtf, .html, .png, .jpg)",
          "button-browse": "Browse files",
          "button-update": "Update resume",
          "update-existing-info": "A new resume will update your education, skills, and experience in MyAquent",
          "invalid-file-type": "Check file type, max upload file size 20MB"
        },
        "submit-application": "Submit Application",
        "update-profile": "Update Profile",
        "join-talent-community": "Join Talent Community",
        "submit-error-header": "Submission Error",
        "submit-error-body": "We encountered an issue processing your application. Please email ",
        "submit-error-message-reference": " and reference",
        "submit-error-message-id": " Error ID# {{errorId}}",
        "profile-url-invalid": "Invalid URL",
        "password-char-limit": "100 character limit reached",
        "add-password": "Add password",
        "password-toggle-label": "password",
        "too-many-links": "You can add up to 6 links total across profile and portfolio URLs",
        "location-mismatch": {
          "modal-header": "Job Position Location",
          "modal-message": "It looks like you are not located in the same country as the position. Is this correct?",
          "search-jobs": "Search for Jobs",
          "continue": "Yes, continue",
          "cannot-accept": "Unfortunately, we cannot accept your application at this moment."
        }
      },
      "email-login-page": {
        "email":"Email or Username",
        "email-general-application": "Email",
        "email-username-invalid": "Please provide a valid email address or username.",
        "continue": "Continue"
      },
      "otp-page": {
        "otp-header": "Enter Verification Code",
        "otp-helper-info": "Please verify your email by entering the 6-digit code sent to {{email}}",
        "otp-code": "Code",
        "otp-resend-helper-info": "Did not receive a code? ",
        "otp-resend": "Resend",
        "otp-invalid": "Invalid Code.",
        "password-invalid": "Invalid password",
        "sign-in-with-password": "Sign in with password",
        "enter-password": "Enter your password",
        "forgot-password": "Forgot Password?",
        "password": "Password",
        "max-attempts": "3 Entries exceeded.",
        "code-expired": "Code has expired."
      },
      "continue": "Continue",
      "back": "Back"
    },
    "pay-transparency" : {
      "later-modal": {
        "header": "Complete your pay rate later?",
        "description": "If so, we will email you a link to continue this portion of the application."
      },
      "submit-modal": {
        "header": "Submit Pay Rate?",
        "description": "You will have an opportunity to review and change this later."
      },
      "pay-rate": {
        "title": "Pay Details",
        "salary": "Annual Salary",
        "hourly": "Hourly Rate",
        "day-rate": "Day Rate",
        "daily": "Daily Rate",
        "project": "Project Rate",
        "pay-range": "Pay Range: {{min}} - {{max}}"
      }
    },
    "job-posting-closed-page": {
      "no-longer-available": "This job is closed, but your next opportunity isn't",
      "job-not-found": "This job cannot be found.",
      "button": "Explore more jobs",
      "body": "",
      "join-our-talent-community": "Join our Talent Community",
      "join-our-talent-community-sub-text": "A complete and visible profile makes you more likely to get matched for an opportunity that fits your background."
    },
    "eeoc-page": {
      "title": "Help us improve inclusivity at Aquent by sharing your demographic information. It’s optional, confidential, and won't affect your application.",
      "gender": "Gender Identity",
      "pronouns": "Pronouns",
      "ethnicity": "Ethnicity",
      "lgbtq": "Do you identify as a member of the LGBTQIA+ community?",
      "disability": "Do you have a disability?",
      "age-group": "Age Group",
      "veteran": "Are you a veteran?",
      "neurodivergent": "Do you identify as Neurodivergent?"
    },
    "country-names": {
      "1": "USA",
      "2": "Canada",
      "3": "Ireland",
      "4": "Germany",
      "5": "France",
      "6": "Japan",
      "7": "China",
      "8": "Australia",
      "9": "UK",
      "10": "Netherlands",
      "11": "Singapore",
      "12": "Sweden",
      "13": "New Zealand",
      "14": "Argentina",
      "15": "Austria",
      "16": "Belgium",
      "17": "Bolivia",
      "18": "Brazil",
      "19": "Chile",
      "20": "Columbia",
      "21": "Costa Rica",
      "22": "Czech Republic",
      "23": "Denmark",
      "24": "Ecuador",
      "25": "Finland",
      "26": "Greece",
      "27": "Guatemala",
      "28": "Honduras",
      "29": "Hong Kong",
      "30": "Hungary",
      "31": "India",
      "32": "Indonesia",
      "33": "Israel",
      "34": "Italy",
      "35": "Korea",
      "36": "Luxembourg",
      "37": "Macau",
      "38": "Malaysia",
      "39": "Mexico",
      "40": "Monaco",
      "41": "Morocco",
      "42": "New Caledonia",
      "43": "Norway",
      "44": "Panama",
      "45": "Paraguay",
      "46": "Peru",
      "47": "Philippines",
      "48": "Poland",
      "49": "Portugal",
      "50": "Puerto Rico",
      "51": "Russia",
      "52": "Slovenia",
      "53": "South Africa",
      "54": "Spain",
      "55": "Switzerland",
      "56": "Taiwan",
      "57": "Thailand",
      "58": "Turkey",
      "59": "Uruguay",
      "60": "Venezuela",
      "61": "Vietnam",
      "62": "United Arab Emirates",
      "63": "Ukraine",
      "64": "Bulgaria",
      "65": "Cambodia",
      "66": "Bahrain",
      "67": "Kuwait",
      "68": "Lebanon",
      "69": "Qatar",
      "70": "Romania",
      "71": "Saudi Arabia"
    },
    "talent-vms": {
      "agreement": "Agreement",
      "right-to-represent": "Right to Represent",
      "right-to-represent-agreement": "Representation Agreement",
      "right-to-represent-text": "I would like to be represented by Aquent for this role.",
      "signature": "Signature",
      "full-name": "Full Name",
      "required": "required",
      "view-job-description": "View job description",
      "birthdate-verification": "Birthdate Verification",
      "birthdate-format": "DOB (MM/DD)",
      "tax-id": "Tax Id",
      "tax-id-format": "Last {{length}} Digits",
      "employment-history": {
        "label": "Employment History",
        "worked-for-client": "Have you worked for {{clientName}} in the past?",
        "select-all-that-apply": "Select all that apply",
        "most-recent-experience": "Most Recent Experience",
        "most-recent-employment-type-experience": "Most Recent {{employmentType}} Experience",
        "dates": "Dates",
        "details": "Details",
        "start-date": "Start Date",
        "end-date": "End Date",
        "date-format": "MM/YYYY",
        "employment-type" : {
          "label": "Employment Type",
          "permanent": "Permanent",
          "contract": "Contract",
          "vendor": "Vendor",
          "intern": "Intern"
        },
        "manager-name": "Manager Name",
        "title": "Title",
        "job-title": "Job Title",
        "department": "Department",
        "previous-client-email": "Previous Client Email",
        "email": "Email",
        "agency-name": "Supplier/Agency Name",
        "type-none-if-no-agency": "Type \"none\" if no agency"
      },
      "relationship-disclosure": {
        "label": "Relationship Disclosure",
        "does-a-family-member-work": "Does a family member work at {{clientName}}?",
        "family-member-name": "Name",
        "relationship": {
          "label": "Relationship",
          "options": {
            "aunt-uncle": "Aunt/Uncle",
            "child": "Child",
            "grandparent": "Grandparent",
            "in-law": "In-Law",
            "other": "Other",
            "parent": "Parent",
            "sibling": "Sibling",
            "spouse-partner": "Spouse/Partner"
          }
        }
      },
      "ernst-and-young-history" : {
        "label": "Ernst & Young (EY) Professional History",
        "have-you-worked": "Are you a former partner, principal, shareholder, or professional employee with Ernst & Young?",
        "engaged-on-account": "Were you engaged on the {{clientName}} account at Ernst & Young?"
      }
    }
  },
  "pay-unit": {
    "hour-abbreviated": "hr",
    "day-abbreviated": "day",
    "year-abbreviated": "year",
    "project-abbreviated": "project"
  },
  "collect": {
    "welcome": {
      "header": "AI SKILLS UPDATE",
      "is-this-you": "Is this you?"
    },
    "intro": {
      "header": "Tell us about your AI Accomplishments.",
      "header-subtext": "This helps us match you to the right opportunities and put you in front of clients who value your AI skills."
    },
    "profile-header": {
      "profile-updated": "Your Aquent profile will be updated.",
      "not-you": "Not you?",
      "logout": "Logout",
      "open-my-aquent": "Open MyAquent"
    },
    "ai-tools": {
      "header": "What AI tools or skills are you proficient in? *",
      "label": "AI tools",
      "placeholder": "eg. Cursor, Motion, DALL-E, Midjourney...",
      "hint": "Press enter to add each tool/skill.",
      "remove-aria": "remove {{skill}}"
    },
    "stories": {
      "header": "Share an AI Success Story",
      "header-optional": "(optional)",
      "header-subtext": "Describe a project that you're particularly proud of.",
      "organization": "Organization or context",
      "organization-placeholder": "Who was this for?",
      "date": "Date",
      "date-placeholder": "Roughly when did this happen?",
      "problem": "What problem were you solving?",
      "problem-placeholder": "What was broken, missing, or frustrating before you got involved?",
      "action": "How did you use AI?",
      "action-placeholder": "Which tools did you use, and what did you actually do with them? Be specific — this is the good stuff.",
      "result": "What was the impact?",
      "result-placeholder": "What got better? Numbers are great, but a clear \"before and after\" works too.",
      "add": "Add a Success Story",
      "remove-aria": "Remove story"
    },
    "save": "Save to profile",
    "thank-you": {
      "header-confirmed-identity": "Thanks for sharing your experience",
      "header-confirmed-identity-subtext": "Keep your resume and stories current as your accomplishments evolve.",
      "header-not-confirmed-identity": "Thanks for letting us know.",
      "add-more-tools": " We’ll match you with AI opportunities based on your profile.",
      "update-skills": "To update your AI skills, sign in to your MyAquent account.",
      "view-my-profile": "View My Profile",
      "open-my-aquent": "Open MyAquent"
    }
  },
  "portfolio-collect": {
    "page-title": "Add your portfolio to Milton | Aquent",
    "header": "Add your portfolio to Milton.",
    "lead": "Milton searches the visual work in your portfolio. Sharing your portfolio URL can help us match you with open jobs.",
    "what-is-milton": "What is Milton, and what happens to my work?",
    "what-is-milton-body-1": "Milton is our proprietary visual search tool. It looks at the images in your portfolio rather than the words on your resume.",
    "what-is-milton-body-2": "That means you can surface for a job because of what you actually made, not because your job title happened to match.",
    "what-is-milton-body-3": "Milton’s only job is matching. It reads the images in a portfolio so we can find the right person for a brief, nothing more.",
    "url": {
      "label": "Your portfolio link",
      "placeholder": "Paste your portfolio link",
      "hint": "Your own site is best, or Behance, Dribbble, ArtStation. Not LinkedIn or a resume page.",
      "error-missing": "Add a link before saving.",
      "error-invalid": "That doesn’t look like a web address. Check it and try again.",
      "error-save-failed": "We couldn’t save that just now."
    },
    "password": {
      "toggle": "This site needs a password",
      "label": "Password",
      "placeholder": "Password for this site",
      "note": "We’ll only use this so Milton can see your work.",
      "show-aria": "Show password",
      "hide-aria": "Hide password"
    },
    "submit": "Add my portfolio",
    "reassurance-lead": "Milton is an internal Aquent tool.",
    "reassurance": "We don’t train AI on your work.",
    "no-portfolio": {
      "header": "I don’t have a portfolio",
      "body": "No problem. Milton only searches visual portfolios, but our recruiters use other resources like LinkedIn and GitHub to match you with open opportunities.",
      "link": "Update my URLs in MyAquent"
    },
    "not-you": "Not you?",
    "sign-in": "Sign in to MyAquent",
    "thank-you": {
      "header": "Thanks, your portfolio will be considered for open jobs",
      "body": "Got more to show us? Another portfolio, a LinkedIn, a GitHub, a reel? You can update all your URLs any time from your profile.",
      "cta": "Sign in to MyAquent"
    }
  }
}
